module.exports = __webpack_public_path__ + "static/media/signature-potato.7d294bc8.png";